<template>
    <div>
        <div class="request_wrap">
            <div class="modelcode_wrap">
                <dl class="request_email">
                    <dt>{{ $t('BUTTON.GLOBAL.EMAIL') }}</dt>
                    <dd>{{ email }}</dd>
                </dl>
                <dl class="request_model">
                    <dt>{{ $t('FIELD.GLOBAL.ETC.007') }}</dt>
                    <dd class="clearable" data-input-type="input">
                        <input
                            type="text"
                            class="text_input w100p"
                            :placeholder="$t('FIELD.GLOBAL.ETC.007')"
                            maxlength="30"
                            v-clearable
                            @keyup.enter.stop="search()"
                            v-model="searchName"
                        />
                        <a href="javascript:" class="in_btn_search" @click="search">
                            <i class="ico_input_serach2"></i><span class="sr_only"></span>
                        </a>
                    </dd>
                </dl>
            </div>

            <div class="schModel_wrap">
                <table class="scroll_table_ty2">
                    <thead class="text_left">
                        <tr>
                            <th width="30px"></th>
                            <th width="90px">{{ $t('FIELD.COUNTRY.NAME') }}</th>
                            <th width="120px">{{ $t('FIELD.SEARCH.MODELS') }}</th>
                            <th width="190px">{{ $t('FIELD.MAJOR.PRODUCT.CATEGORY') }}</th>
                            <th width="190px">{{ $t('FIELD.SUB.PRODUCT.CATEGORY') }}</th>
                        </tr>
                    </thead>
                    <tbody class="scrollbar-inner height_190">
                        <!-- scroll_ty2 -->
                        <tr v-for="item in modelList" :key="'modelList' + item.NATION_CD + item.MODEL_CD">
                            <td width="30px" class="no_pading text_center">
                                <label class="radiobox-wrap2">
                                    <input
                                        type="radio"
                                        name="modelList"
                                        :value="item.MODEL_CD"
                                        @change="
                                            modelChange(
                                                $event,
                                                item.NATION_CD,
                                                item.NATION_NM,
                                                item.MODEL_CD,
                                                item.PRD_CATEGORY_NM1,
                                                item.PRD_CATEGORY_NM2,
                                            )
                                        "
                                    />
                                    <i class="radio-icon"></i>
                                </label>
                            </td>
                            <td width="90px" class="text_left ellipsis" :title="item.NATION_NM">
                                {{ item.NATION_NM }}
                            </td>
                            <td width="120px" class="text_left ellipsis" :title="item.MODEL_CD">
                                {{ item.MODEL_CD }}
                            </td>
                            <td width="190px" class="text_left ellipsis" :title="item.PRD_CATEGORY_NM1">
                                {{ item.PRD_CATEGORY_NM1 }}
                            </td>
                            <td width="190px" class="text_left ellipsis" :title="item.PRD_CATEGORY_NM2">
                                {{ item.PRD_CATEGORY_NM2 }}
                            </td>
                        </tr>
                        <tr v-show="0 === modelList.length">
                            <td colspan="4">
                                <ul class="ul_list">
                                    <li class="nodata">
                                        <span>{{ $t('FIELD.GLOBAL.NODATA') }}</span>
                                    </li>
                                </ul>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="youSelected_wrap">
                <h3>{{ $t('FIELD.YOU.SELECT') }}</h3>
                <div class="youSelected_box">
                    <article class="selectd_info">
                        <dl>
                            <dt>{{ $t('FIELD.GLOBAL.MODEL.CODE') }}</dt>
                            <dd>{{ selectModelCode }} {{ selectCountryNm }}</dd>
                        </dl>
                        <dl>
                            <dt>{{ $t('FIELD.GLOBAL.PRODUCT.CATEGORY') }}</dt>
                            <dd>{{ selectProductCategory }}</dd>
                        </dl>
                    </article>
                    <article class="selected_chk">
                        <dl>
                            <dt>
                                <!-- <em class="txt_mandatory">*</em> -->
                                {{ $t('MESSAGE.AVAILABLE.REPAIR.INFORMATION') }}
                            </dt>
                            <dd>
                                <ul class="ul_list">
                                    <li v-for="(item, idx) in contentsList" :key="'contentsList' + item.CODE">
                                        <div class="one-checkBox check_agree">
                                            <input
                                                type="checkbox"
                                                :id="'checkbox' + idx"
                                                v-model="item.CHECK_YN"
                                                true-value="Y"
                                                false-value="N"
                                            />
                                            <label :for="'checkbox' + idx">
                                                <span></span><em>{{ item.CODE_NM }}</em>
                                            </label>
                                        </div>
                                    </li>
                                    <li class="nodata" v-if="0 === contentsList.length">
                                        <span v-html="noData"></span>
                                    </li>
                                </ul>
                            </dd>
                        </dl>
                    </article>
                </div>
            </div>
        </div>
        <div class="one-btn-wrap">
            <button class="bt-type-b" @click="goListBack">{{ $t('BUTTON.GLOBAL.CANCEL') }}</button>
            <button class="bt-type-b blue" @click="save">{{ $t('BUTTON.GLOBAL.SUBMIT') }}</button>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { SDLUtil, StringUtil } from '@/utils';
import qs from 'query-string';
import axios from 'axios';
import constants from '@/constants';
import store from '@/vuex/store';
import scrollbar from '/static/js/jquery.scrollbar.js';
import RequestSuccPopup from '~vb/eur/user/RequestSuccPopup';
import { i18n, loadLanguageAsync } from '@/i18n';

export default {
    name: 'RequestRepairInfo',
    components: {
        scrollbar,
    },
    computed: {
        ...mapGetters({
            loginId: 'getLoginId',
            corpNo: 'getCorpNo',
            langCd: 'getLangCd',
            email: 'getEmail',
            countryCd: 'getCountryCd',
            loginCountryCd: 'getLoginCountryCd',
        }),
    },
    data() {
        return {
            searchName: '',
            modelList: [],
            contentsList: [],
            selectCountryCd: '',
            selectCountryNm: '',
            selectModelCode: '',
            selectProductCategory: '',
            noData: SDLUtil.getMsgProp('FIELD.GLOBAL.NODATA'),
        };
    },
    methods: {
        async search() {
            if (SDLUtil.textLength(this.searchName) < 10) {
                SDLUtil.alert(SDLUtil.getMsgProp('MESSAGE.TEXT.LENGTH.OVER', ['10']));
                return false;
            } else {
                $('input[name=modelList]').prop('checked', false);
                this.selectCountryCd = '';
                this.selectCountryNm = '';
                this.selectModelCode = '';
                this.selectProductCategory = '';
                this.contentsList = [];
            }

            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/noauth/eur/getModelList.skp`,
                    qs.stringify({
                        searchName: this.searchName,
                        locale: this.langCd,
                        countryCd: this.countryCd,
                        loginCountryCd: this.loginCountryCd,
                    }),
                )
                .then(resp => {
                    this.modelList = resp.data.result.rowData;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        async modelChange(e, v1, v2, v3, v4, v5) {
            this.selectCountryCd = v1;
            this.selectCountryNm = '(' + v2 + ')';
            this.selectModelCode = v3;
            this.selectProductCategory = v4 + '/' + v5;

            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/noauth/eur/getContentsList.skp`,
                    qs.stringify({
                        countryCd: this.selectCountryCd,
                        modelCd: this.selectModelCode,
                        langCd: this.langCd,
                    }),
                )
                .then(resp => {
                    SDLUtil.showLoadingBar(false);
                    this.contentsList = resp.data.result.rowData;
                    if (0 === this.contentsList.length) {
                        this.getNoDataMsg();
                    }
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        async getNoDataMsg() {
            this.noData = SDLUtil.getMsgProp('FIELD.GLOBAL.NODATA');
            if (!SDLUtil.isNull(this.selectModelCode)) {
                SDLUtil.showLoadingBar(true);
                return await axios
                    .post(
                        `${SDLUtil.API_URL}/noauth/eur/getAvailableContentsMsg.skp`,
                        qs.stringify({
                            countryCd: this.selectCountryCd,
                            modelCd: this.selectModelCode,
                        }),
                    )
                    .then(resp => {
                        SDLUtil.showLoadingBar(false);
                        if ('Y' === resp.data.result) {
                            this.noData += '<br>';
                            this.noData += SDLUtil.getMsgProp('MESSAGE.EUR.SALES.NO.DATA');
                        }
                    })
                    .catch(err => {
                        Vue.$log.error(err);
                        SDLUtil.errorAlert(err);
                        SDLUtil.showLoadingBar(false);
                    });
            }
        },
        async getApprovalWait() {
            let message = SDLUtil.getMsgProp('MESSAGE.EUR.APPROVAL.WAIT');
            const params = { bpNo: this.loginId, approvalNotStatus: 'Y' };
            const url = `${SDLUtil.API_URL}/noauth/eur/getRequestList.skp`;
            axios
                .post(url, qs.stringify(params))
                .then(resp => {
                    SDLUtil.showLoadingBar(false);
                    if (0 < resp.data.search.totalRecords) {
                        SDLUtil.alert({
                            msg: message,
                            onOkEvt: () => {
                                this.goListBack();
                            },
                        });
                    }
                })
                .catch(err => {
                    SDLUtil.showLoadingBar(false);
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                });
        },
        async save() {
            SDLUtil.showLoadingBar(true);
            const idx = this.contentsList.findIndex(function(item) {
                return item.CHECK_YN === 'Y';
            });

            if (0 > idx) {
                SDLUtil.showLoadingBar(false);
                SDLUtil.alert('MESSAGE.SELECT.MORE.THAN.ONE');
                return false;
            }
            let contents = '';
            let contentsName = '';
            let contsNum = '';
            for (const data of this.contentsList) {
                if ('Y' === data.CHECK_YN.trim()) {
                    if (!SDLUtil.isNull(contents)) contents += ',';
                    if (!SDLUtil.isNull(contentsName)) contentsName += ',';
                    if (!SDLUtil.isNull(contsNum)) contsNum += ',';
                    contents += data.CODE.trim();
                    contentsName += data.CODE_NM.trim();
                    contsNum += data.CONTS_NUM;
                }
            }
            let countryCd = this.selectCountryCd;
            let modelCode = this.selectModelCode;

            const index = this.modelList.findIndex(function(item) {
                return item.MODEL_CD === modelCode;
            });

            let prdCategoryCd1 = this.modelList[index].PRD_CATEGORY_CD1;
            let prdCategoryCd2 = this.modelList[index].PRD_CATEGORY_CD2;

            return await axios
                .post(
                    `${SDLUtil.API_URL}/noauth/eur/saveRequestRepairInfo.skp`,
                    qs.stringify({
                        bpNo: this.loginId,
                        langCd: this.langCd,
                        countryCd: countryCd,
                        modelCode: modelCode,
                        prdCategoryCd1: prdCategoryCd1,
                        prdCategoryCd2: prdCategoryCd2,
                        contents: contents,
                        contentsName: contentsName,
                        contsNum: contsNum,
                    }),
                )
                .then(resp => {
                    let msg = resp.data.msg;
                    SDLUtil.showLoadingBar(false);

                    let show = false;
                    if (document.location.href.indexOf('joinUser') > -1) {
                        show = true;
                    }

                    this.RequestSuccPopup({
                        msg1: SDLUtil.getMsgProp('MESSAGE.EUR.REQ.SUCCESS'),
                        msg2: SDLUtil.nvl(SDLUtil.getMsgProp(msg)),
                        msg3: SDLUtil.getMsgProp('MESSAGE.EUR.WAIT.APPROVAL'),
                        msg4: SDLUtil.getMsgProp('MESSAGE.EUR.AFTER.APPROVAL'),
                        msg5: SDLUtil.getMsgProp('MESSAGE.EUR.REQ.INFO.EMAIL'),
                        mon: resp.data.admin.USER_EXPIRE_MON,
                        show: show,
                    });
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        goListBack() {
            this.$router.push(`${SDLUtil.WEB_CONTEXT_PATH}/erp/repairInfoHist`);
        },
        RequestSuccPopup(v) {
            SDLUtil.show(
                RequestSuccPopup,
                {
                    data: v,
                    rtnFunc: () => {
                        return this.goListBack();
                    },
                },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
    },
    mounted() {
        store.commit('LANG_CD', this.langCd);
        loadLanguageAsync(this.langCd);
        this.$nextTick(() => {
            $('.scrollbar-inner').scrollbar();
            window.setTimeout(() => {
                this.getNoDataMsg();
                this.getApprovalWait();
            }, 500);
        });
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/user/RequestRepairInfo.vue